import { get } from 'lodash-es';
import { EdmundsAPI } from 'client/data/api/api-client';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { logger } from 'client/utils/logger/logger';
import { getMetricsHeaders } from 'client/utils/metrics-header';
import { SessionRecorder } from 'client/utils/session-recorder/session-recorder';

const EMAIL_PHONE_VALIDATION_URL = '/uservalidation/v2/validatecontact';

/**
 * Prepares a map of required request options
 */
export function requestOptions({ firstName, lastName, phone, email }, options) {
  const name = `${firstName} ${lastName}`.trim();
  const { pageName, venomVersion } = options;
  return {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...getMetricsHeaders('asyncValidation', pageName, venomVersion),
    },
    method: 'POST',
    body: objectToQueryString({ name, phone, email }),
  };
}

/**
 * Asynchronous email/phone validation by using validation-rest-web API
 * @param {string} [id=] Page (Component) identifier
 * @param {string} [firstName=]
 * @param {string} [lastName=]
 * @param {string} [phone=]
 * @param {string} [email=]
 */
function fetchEmailPhoneValidation({ id = '', firstName = '', lastName = '', phone = '', email = '' }, options = {}) {
  const reqOptions = requestOptions({ firstName, lastName, phone, email }, options);
  const isSessionRecorderActive = get(options, 'isSessionRecorderActive');

  return EdmundsAPI.fetchJson(`${EMAIL_PHONE_VALIDATION_URL}?id=${id}`, reqOptions)
    .then(response => {
      const result = {};

      if (phone) {
        result.isPhoneValid = response.phoneValid;
      }
      if (email) {
        result.isEmailValid = response.emailValid;
      }
      return result;
    })
    .catch(error => {
      if (isSessionRecorderActive) {
        SessionRecorder.addTag('#error');
      }
      logger.error(error);
      return { isPhoneValid: true, isEmailValid: true };
    });
}

/**
 * Shortcut to validate only email
 */
function fetchEmailValidation({ id, firstName, lastName, email }, options) {
  return fetchEmailPhoneValidation({ id, firstName, lastName, email }, options);
}

/**
 * Shortcut to validate only phone
 */
function fetchPhoneValidation({ id, firstName, lastName, phone }, options) {
  return fetchEmailPhoneValidation({ id, firstName, lastName, phone }, options);
}

export const asyncValidation = {
  fetchEmailValidation,
  fetchPhoneValidation,
  fetchEmailPhoneValidation,
};
